/**
 * Created by Administrator on 2018/1/3 0003.
 */
export default [
  {
    path: '/home',
    alias: '/',
    component: resolve => require(['../views/home/Index.vue'], resolve)
  },
  {
    name: 'detail',
    path: '/detail',
    component: resolve => require(['../views/detail/Index.vue'], resolve)
  },
  {
    path: '/team',
    component: resolve => require(['../views/team/Index.vue'], resolve)
  },
  {
    path: '/join',
    component: resolve => require(['../views/join/Index.vue'], resolve)
  },
  {
    path: '*',
    name: '404',
    component: resolve => require(['../views/error/404.vue'], resolve)
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js